// extracted by mini-css-extract-plugin
export default {"mediaOrigin":"mediaOrigin__YFpqzx","mediaOriginLabel":"mediaOriginLabel__uP9OVq"};